<template>
<div class="modal-card">
  <div class="modal-card-body" style="width:645px; height:500px;" v-if="loading">
    <b-loading :is-full-page="false" :active="loading"></b-loading>
  </div>
  <div v-else-if="policy.error" class="modal-card-body">
    <b-message  type="is-danger" aria-close-label="Close message">
      Rate details unavailable
    </b-message>
  </div>
  <div v-else class="card" style="width:645px">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-hidden-touch">Fees, Taxes, and Optional Services</p>
        <p class="modal-card-title is-hidden-desktop">Fees, Taxes, and Options </p>


                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body">
                      <div v-for="opt in Object.keys(options)" :key="opt">
                        <p style="border-bottom: dotted 1px; border-color: #F8E8E1; font-weight: bold;">
                          {{conversions[opt] }} information
                        </p>
                        <div v-for="res in options[opt]" :key="res[0]">
                          <span class="is-size-6 caps">
                              {{res[0].toLowerCase()}}
                          </span>
                          <span class="is-block is-size-6 is-pulled-right">
                              {{ res[2] }}{{ res[1]}} 
                          </span><br />
                        </div>
                        <br />

                      </div>



                    </section>

    </div>
  </div>

</div>

</template>

<script>

  export default {
    name: 'RateInfoModal',
    props: {
        sol: Object,
        searchBody: Object
      },
    data: function () {
          return {
            isOpen: 0,
            policy: {},
            loading: true,
            conversions: {
              '108':	'Surcharge',
              '013':	'Special equipment',
              '045':	'Tax',
              'COL':	'Collection',
              'COV':	'Coverage',
              'CPN':	'Coupon',
              'DEL':	'Delivery',
              'INS':	'Insurance'
            }
        }
      },
    computed: {
      cancelPolicy() {
        try {
          if (Array.isArray(this.policy.data.cancelPenalty.Description) ){
            return this.policy.data.cancelPenalty.Description
          }
          else if (this.policy.data.cancelPenalty.Description == null){
            return null
          }
          else {
            return [this.policy.data.cancelPenalty.Description]
          }
        }
        catch {
          return null
        }
      },
      options() {
        if (this.policy.rateDetails){
          var ops = this.policy.rateDetails.taxCovSurchargeGroup
          var res = {}
          for (var i = 0; i < ops.length; i++){
            if (ops[i].taxSurchargeCoverageInfo.chargeDetails.comment){
              if (!res[ops[i].taxSurchargeCoverageInfo.chargeDetails.type]){
                res[ops[i].taxSurchargeCoverageInfo.chargeDetails.type] = []
              }
              res[ops[i].taxSurchargeCoverageInfo.chargeDetails.type].push([
                ops[i].taxSurchargeCoverageInfo.chargeDetails.comment.split(' - ')[1],
                ops[i].taxSurchargeCoverageInfo.chargeDetails.amount,
                this.$helpers.getCurrencySymbol(ops[i].taxSurchargeCoverageInfo.chargeDetails.currency)
              ])
            }
          }
          return res
        }
        else {
          return {}
        }
      },
      rateDescription() {
        try {
          if (Array.isArray(this.policy.data.RatePlanDescription.Text) ){
            return this.policy.data.RatePlanDescription.Text
          }
          else if (this.policy.data.RatePlanDescription.Text == null){
            return null
          }
          else {
            return [this.policy.data.RatePlanDescription.Text]
          }
        }
        catch {
          return null
        }
      }
    },
    methods: {
        async getRules() {

          var raw = {
              "stateful": true,
              "sessionKey": null,
              "normalizeResponse": false,
              "pickupDate": this.sol.pickupInfo.dateTime,
              "dropoffDate": this.sol.dropoffInfo.dateTime,
              "companyCode": this.sol.companyInfo?.code || this.sol.vendorCode,
              "pickupLocation": this.sol.pickupInfo.locationKey?.split('-')[0] || this.sol.pickupInfo.location,
              "dropoffLocation": this.sol.dropoffInfo.locationKey?.split('-')[0] || this.sol.dropoffInfo.location,
              "rateInformation": this.sol.rateInformation,
              "requestedCurrency": this.sol.pricingInfo.currencyCode,

              // {
              //   "corporateDiscountNumber": "XZ23262",
              //   "rateCode": "Z1X90Y",
              //   "rateIdentifier": "ANDXS",
              //   "ratePlanIndicator": this.sol.rateInformation.ratePlanIndicator,
              //   "rateCategory": this.sol.rateInformation.rateCategory
              // },
              // {
              //     "rateCode": this.sol.rateInformation.rateCode,
              //     "rateType": this.sol.rateIdentifier,
              //     "ratePlanIndicator": this.sol.rateCategory,
              //     "category": null
              // },
              "vehicleInfo": {
                  "preferredVehicleType": this.sol.carCode ||this.sol.vehicleInfo?.code
              }
          }
          // console.log('raw:', JSON.stringify(raw));

          try {
            this.$app.huddleLabsServerCall('amadeus/car/rate-info', raw)
              .then(result => {this.expiredCheck(result)})
          }
          catch {
            this.loading = false;
            this.policy.error = true;
          }

        },
        expiredCheck(result){
          if (result.response){
            if (result.response.errorWarning){
              if (result.response.errorWarning.applicationError.errorDetails.errorCode == '99'){
                // this.loading = false
                this.loading = false
                this.policy.error = true
                // this.$app.huddleLabsServerCall('amadeus/car/search', this.searchBody)
                //   .then(result => {
                //     // console.log('updated');
                //     this.getRules()
                //   })
              }
              else{
                this.policy = result.response;
                this.loading = false;
                // console.log(result.error);
              }
            }
            else{
              this.policy = result.response;
              this.loading = false;
              // console.log(result.error);
            }



          }
          else{
            this.loading = false
            this.policy.error = true

          }
        }
    },
    mounted () {
      this.getRules();
    },
}

</script>

<style scoped>
  .caps{
    /* text-transform: lowercase; */
    text-transform: capitalize;
  }
</style>
